type SubscriptionCallback = (...params: unknown[]) => Promise<{ unsubscribe: () => void }>;

class _SubscriptionEventBus {
    private bus: Record<string, SubscriptionCallback>;
    private currentSubscriptions: Record<string, { unsubscribe: () => void }>;

    constructor() {
        this.bus = {};
        this.currentSubscriptions = {};
    }

    async prepare(id: string, callback: SubscriptionCallback) {
        this.bus[id] = callback;
    }

    async subscribe(id: string, ...params: unknown[]) {
        if (!this.currentSubscriptions[id]) {
            try {
                if (this.bus[id]) {
                    const observer = await this.bus[id](...params);
                    this.currentSubscriptions[id] = observer;
                } else {
                    console.warn(`No subscription prepared for id: ${id}`);
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    async unsubscribe(id: string) {
        const subscription = this.currentSubscriptions[id];
        if (subscription) {
            await subscription.unsubscribe();
            delete this.currentSubscriptions[id];
        }
    }

    async unsubscribeAll() {
        for (const id in this.currentSubscriptions) {
            await this.currentSubscriptions[id].unsubscribe();
            delete this.currentSubscriptions[id];
        }
    }
}

export const SubscriptionEventBus = new _SubscriptionEventBus();
